module.exports = __webpack_public_path__ + "img/XMLID_830.b0a75620.svg";